import React, { FC } from "react";
type ButtonProps = {
  title?: string;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  data?: string;
  children?: React.ReactNode;
  type?: "submit" | "reset" | "button" | undefined;
};

const Button: FC<ButtonProps> = (props) => {
  return (
    <button
      onClick={props.onClick}
      className={
        props.data == "SIGN IN"
          ? `${props.className}`
          : `button ${props.className}`
      }
      disabled={props.disabled}
      type={props.type ?? "button"}
    >
      {props.children || props.data}
    </button>
  );
};

export default Button;
